import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";

import { addOrganisation as addOrganisationAPI } from "api/organisations";
import { organisationsKeys } from "api/organisations/queries";
import { NewOrganisationPayloadType } from "api/organisations/types";
import AppDialog from "components/AppDialog";
import ModalHeader from "components/AppDialog/ModalHeader";

import OrganisationForm, { OrganisationFormValues } from "./OrganisationForm";

// LOGIC:

// TYPES:

interface NewOrganisationModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

const NewOrganisationModal = ({
  isOpen,
  handleClose,
}: NewOrganisationModalProps) => {
  const queryClient = useQueryClient();

  const { mutateAsync: addOrganisation, status } = useMutation(
    async (data: NewOrganisationPayloadType) => {
      const res = await addOrganisationAPI(data);
      await queryClient.invalidateQueries(organisationsKeys.list());
      return res.data;
    },
  );

  const handleSubmit = async (values: OrganisationFormValues) => {
    await addOrganisation(values, {
      onSuccess: () => handleClose(),
    });
  };

  return (
    <AppDialog open={isOpen} onClose={handleClose} maxWidth="lg">
      <ModalHeader
        title="New Organisation"
        subtitle="Add a new organisation and configure settings."
      />
      <OrganisationForm
        submitStatus={status}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
      />
    </AppDialog>
  );
};

export default NewOrganisationModal;
